import { useEffect, useMemo, useState } from "react";
import { StaffApiSchema } from "@apiUtils/index";

export type StaffAppNavEntry = StaffApiSchema.components["schemas"]["StaffAppNavigation"];

/** Staff NAF apps for the sidebar, already filtered by the server to the ones this user may run. */
export function useStaffApps(): Record<string, StaffAppNavEntry[]> {
  const [entries, setEntries] = useState<StaffAppNavEntry[]>([]);

  useEffect(() => {
    let cancelled = false;

    fetch("/api/naf/navigation/")
      .then((response) => (response.ok ? response.json() : []))
      .then((data: StaffAppNavEntry[]) => {
        if (!cancelled && Array.isArray(data)) setEntries(data);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, []);

  return useMemo(() => {
    const bySection: Record<string, StaffAppNavEntry[]> = {};
    for (const entry of entries) {
      (bySection[entry.section] ||= []).push(entry);
    }
    return bySection;
  }, [entries]);
}
